export default __webpack_public_path__ + "static/758-f7cb0e1017b98c20b308948abb3dcc72.gif";